import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Text } from '../../components/text/text';
import { pickAriaProps } from '../../utils/aria/aria';
import { pickDataAttributes } from '../../utils/pickDataAttributes/pickDataAttributes';
import { ElementOrIcon } from '../elementOrIcon/elementOrIcon';
import { TextComponentType } from '../text/types/component';
import { TagContainerStyled } from './tag.styled';
const TagStandAloneComponent = ({ dataTestId = 'tag', ...props }, ref) => {
    const ariaProps = pickAriaProps(props);
    const dataAttributes = pickDataAttributes(props);
    return (_jsxs(TagContainerStyled, { ref: ref, as: props.component, "data-testid": dataTestId, styles: props.styles, ...ariaProps, ...dataAttributes, children: [_jsx(ElementOrIcon, { customIconStyles: props.styles.icon, ...props.icon }), _jsx(Text, { component: TextComponentType.SPAN, customTypography: props.styles.label, ...props.label, children: props.label?.content })] }));
};
/**
 * @description
 * Tag component is used to highlight or categorize important information.
 */
export const TagStandAlone = React.forwardRef(TagStandAloneComponent);
//# sourceMappingURL=tagStandAlone.js.map